import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { CompanyPicker } from 'pages/BillRates/components/CompanyPicker'
import { useCompumaticClockPunchesContextValue } from '../context/CompumaticClockPunchesProvider'
import { ClockPicker } from './ClockPicker'
import { StatusPicker } from './StatusPicker'

export const CompumaticClockPunchesFilters = () => {
  const {
    state: { companyId, vendorClockId, status },
    actions: { setCompanyId, setVendorClockId, setStatus },
  } = useCompumaticClockPunchesContextValue()

  return (
    <Flex
      gap={3}
      mb={3}
      flexDirection={['column', 'column', 'row']}
      alignItems={['stretch', 'stretch', 'center']}
      maxWidth={['100%', '100%', '100%', '100%']}
    >
      <Box flex={1} minWidth={0}>
        <CompanyPicker value={companyId} onChange={setCompanyId} />
      </Box>
      <Box flex={1} minWidth={0}>
        <ClockPicker
          companyId={companyId}
          value={vendorClockId}
          onChange={setVendorClockId}
        />
      </Box>
      <Box flex={1} minWidth={0}>
        <StatusPicker value={status} onChange={setStatus} />
      </Box>
    </Flex>
  )
}
